import { FormattedMessage, useIntl } from 'react-intl';
import { cx } from '@emotion/css';
import { JSX, ReactNode } from 'react';

import { useStyles } from './section-title.styles';
import { SectionTitleProps } from './section-title.models';

export const SectionTitle = ({
  title, content, isVertical, isLight, id, colorPart, isTitleLineBreak, isFullWidth,
}: SectionTitleProps): JSX.Element => {
  const classes = useStyles();
  const intl = useIntl();

  return (
    <div
      className={cx(classes.root, { [classes.vertical]: isVertical })}
      data-testid="card"
    >
      <h2
        data-testid="section-title"
        className={cx(classes.title,
          { [classes.light]: isLight, [classes.fullWidth]: isFullWidth })}
        id={id}
        tabIndex={-1}
      >
        {colorPart && (
          <span
            className={cx(classes.color,
              { [classes.block]: isTitleLineBreak },
            )}
          >
            <FormattedMessage id={colorPart} />
          </span>
        )}
        <FormattedMessage id={title} />
      </h2>
      {content && (
        <p
          className={cx(classes.content, { [classes.light]: isLight })}
          data-testid="section-content"
        >{intl.formatMessage(
          { id: content },
          { span: (chunk: ReactNode) => <span className={classes.newLine}>{chunk}</span> },
        )}</p>
      )}
    </div>
  );
};
